<mat-toolbar color="accent">
  {{ request.filter ? 'Edit' : 'Add' }} Report Filter
</mat-toolbar>

<mat-dialog-content class="!text-black">
  <div class="flex flex-col gap-4">
    @if (request.filter?.placeholderMessage; as placeholderMessage) {
      <pr-information-box>
        {{ placeholderMessage }}
      </pr-information-box>
    }

    <pr-datapoint-selector
      class="flex grow"
      label="Select a filter"
      [dataSource]="request.dataSource"
      [measures]="measures"
      [datapointId]="filterChanges()?.id"
      (datapointIdChange)="datapointSelected($event)"
    />

    <pr-edit-report-filter
      class="flex"
      [dataSource]="request.dataSource"
      [filter]="filterChanges()"
      (filterChange)="onFilterChange($event)"
    />
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  @if (request.filter) {
    <button
      mat-stroked-button
      color="warn"
      tabindex="-1"
      (click)="delete(request.filter)"
    >
      <mat-icon>delete</mat-icon> Delete
    </button>
  }
  <span class="flex grow"></span>
  <button mat-stroked-button mat-dialog-close tabindex="-2" type="button">
    Cancel
  </button>
  <button mat-flat-button color="primary" (click)="submit()">
    {{ request.filter ? 'Save' : 'Add' }} Filter
  </button>
</mat-dialog-actions>
